var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.343,
    height: 18.28,
    viewBox: "0 0 22.343 18.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-child-care",
    "data-name": "Icon material-child-care",
    transform: "translate(-1.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36648",
    "data-name": "Trac\\xE9 36648",
    d: "M22.414,15.144a1.269,1.269,0,1,1-1.269-1.269A1.269,1.269,0,0,1,22.414,15.144Z",
    transform: "translate(-5.934 -3.028)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36649",
    "data-name": "Trac\\xE9 36649",
    d: "M14.914,15.144a1.269,1.269,0,1,1-1.269-1.269A1.269,1.269,0,0,1,14.914,15.144Z",
    transform: "translate(-3.512 -3.028)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36650",
    "data-name": "Trac\\xE9 36650",
    d: "M23.782,14.31a3.717,3.717,0,0,0,0-1.341,4.07,4.07,0,0,0-2.854-3.219A9.256,9.256,0,0,0,18.7,6.8,9.131,9.131,0,0,0,4.415,9.751,4.056,4.056,0,0,0,1.561,12.97a3.717,3.717,0,0,0,0,1.341A4.07,4.07,0,0,0,4.415,17.53a9.116,9.116,0,0,0,2.2,2.935,9.082,9.082,0,0,0,12.116,0,9.227,9.227,0,0,0,2.2-2.935,4.06,4.06,0,0,0,2.844-3.219Zm-4,1.361a2.9,2.9,0,0,1-.295-.03,7.28,7.28,0,0,1-.873,1.889,7.092,7.092,0,0,1-11.882,0,7.28,7.28,0,0,1-.873-1.889,2.9,2.9,0,0,1-.295.03,2.031,2.031,0,0,1,0-4.062,2.9,2.9,0,0,1,.295.03A7.28,7.28,0,0,1,6.73,9.751a7.092,7.092,0,0,1,11.882,0,7.28,7.28,0,0,1,.873,1.889,2.894,2.894,0,0,1,.295-.03,2.031,2.031,0,0,1,0,4.062Zm-11.679,0a4.951,4.951,0,0,0,9.14,0Z",
    transform: "translate(0)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedBaby);
export default __webpack_public_path__ + "static/media/bedBaby.e93f9b3ce49e5daf80cbbcfb14de4036.svg";
export { ForwardRef as ReactComponent };